<template>
        <div class="col-xl-6 col-12 d-flex flex-wrap justify-content-center justify-content-xl-start align-content-start align-items-start mt-md-4 mt-xl-0">
            <div class="col-xxl-8 col-10 text-start t-24 t-sm-18 t-md-24 t-xl-12 lh-1 t-xxl-9 label-1 mb-4 mt-4 mt-xl-0">
                Elige un Monto
            </div>
            <div class="col-xl-12 col-10 d-flex flex-nowrap justify-content-between justify-content-sm-start justify-content-xl-start align-content-start align-items-start mb-2 ps-xl-4">
                <div role="button" @click="setValue('step1', 'amount', amount)" class="col-4 flex-shrink-1 col-md-auto buttonAmount px-xl-3 px-2 px-sm-3 py-2 text-center t-19 t-xl-10  t-xxl-5" :class="formFields.step1.amount.id === amount.id ? 'active'+(((aidx+1) % 3) == 0 ? '' : ' me-2 me-sm-4') : (((aidx+1) % 3) == 0 ? '' : ' me-2 me-sm-4')" v-for="(amount, aidx) in amounts" :key="aidx">$ {{amount.value}}</div>
            </div>
            <div class="col-xxl-8 col-10 text-start t-24 t-sm-18 t-md-24 t-xl-12 lh-1 t-xxl-9 label-1 mb-4 mt-4 mt-xl-5">
                ¿A quién vamos a sorprender?
            </div>
            <div
                class="col-xxl-8 col-10 d-flex justify-content-start align-content-start align-items-start ps-xl-4">
                <input ref="receiverName" type="text" maxlength="20" autocomplete='off' spellcheck='false' autocorrect='off'
                    class="w-100 inputText t-xxl-4 t-16 t-sm-11 t-xl-8" placeholder="Ej. Ana, Juan, Familia Pérez"
                    v-model="formFields.step1.receiverName" @paste="pasteFilterLetter($event)" @copy="disableCopy"
                    @keydown="onlyLetters($event)">
            </div>
            <div class="col-xxl-8 col-10 text-start ts-2 mt-5 d-flex justify-content-end">
                <button class="generalButton t-xl-12 t-xxl-8 t-30 t-sm-24" @click="validateNextness()">Continuar</button>
            </div>
        </div>

</template>

<script>
import designList from '@/components/designList.vue'

export default {
    name: 'step1',
    emits:['setData', 'progress', 'showModal', 'setLoading'],
    components:{
        designList,
    },
    props: {
        lang:{
            default:"es",
            type: String
        },
        con:{
            default:{},
            type: Object
        },
        formFields: {},
        cities:{
            default:[],
            type: Array
        }
    },
    mounted(){
        if(this.formFields.step1.amount.id==''){
            this.setValue('step1', 'amount', this.amounts[0]);
        }
    },
    methods:{
        
        setValue(step, field, value){
            let form = this.formFields[step];
            form[field] = value;
            this.$emit('setData', form, step);
        },
        step(step){
            this.$emit('progress', step);
        },
        setErr(name){
            this.$refs[name].classList.add('err')
        },
        removeErr(name){
            this.$refs[name].classList.remove('err')
        },
        validateNextness(){
            let receiverName = this.validateField('text', this.formFields.step1.receiverName, 24, 3);

            if(receiverName){
                this.removeErr('receiverName')
            }else{
                this.setErr('receiverName')
            }
            if(receiverName){
                this.step(1)
            }
        },
    },
    data() {
        return {
            simbol:require('@/assets/images/a27.svg'),
            amounts:[
                {value: 500, id:6001},
                {value: 700, id:6002},
                {value: 1000, id:6003}
            ]
        }
    }
}
</script>

<style scoped lang="css">

.label-1{
    line-height: 2;
    font-weight: 700;
    color:var(--secondaryText)
}

.buttonAmount{
    background-color: var(--tertiary);
    border:3px solid var(--quinary);
    color: var(--quinary);
    font-weight: 600;
    min-width: 70px;
    border-radius:13px; 
}

.buttonAmount.active{
    background-color: var(--secondary);
    border:3px solid transparent;
    color: var(--tertiary);
}

.inputText {
    border: 2px solid var(--quartenary);
    border-radius: 12px;
    padding: 13px;
    outline: none;
    color: var(--primary);
}

@media (min-width: 768px) {
    .buttonAmount{
        min-width: 120px;
    }
}

</style>
